module.exports = __webpack_public_path__ + "img/help.1f726098.jpg";